"use client"
import { useEffect, useState } from "react"
import { cx } from "@/utils/cx"
import { Component } from "@/types/types"

import { Stack } from "@/ui/atoms/layout/Stack"
import { BrandMark } from "@/ui/atoms/branding/BrandMark"
import { SplashLayout } from "@/ui/layouts/SplashLayout"
import { BrandTagline } from "@/ui/atoms/branding/BrandTagline"
import { TextLink } from "@/ui/atoms/controls/TextLink"

import { DemoSignUpForm } from "./_sections/DemoSignUpForm"
import { DemoSignUpConfirmation } from "./_sections/DemoSignUpConfirmation"
import { DemoSignUpDisabledNotice } from "./_sections/DemoSignupDisabledNotice"
import { trackEvent } from "@/actions/telemetry/trackEvent"
import { useSearchParams } from "next/navigation"

export const COMPONENT_NAME = "demoSignUpForm"

export const presets = {}

export interface Props extends Component {
  demoSignUpEnabled: boolean
}

export function DemoSignUpView({ demoSignUpEnabled, className, testId = COMPONENT_NAME }: Props) {
  const [panel, setPanel] = useState<"form" | "success" | "disabled">(
    demoSignUpEnabled ? "form" : "disabled",
  )
  const [email, setEmail] = useState("")
  const searchParams = useSearchParams()
  const forceDisableSignUp = searchParams.get("showDemoSignUpDisabledNotice") === "1"

  useEffect(() => {
    if (forceDisableSignUp) {
      setPanel("disabled")
    }
  }, [forceDisableSignUp])

  // const salesRefQueryString = searchParams.get("salesRef")

  function handleSuccess(email: string) {
    setEmail(email)
    setPanel("success")
    trackEvent(`Demo sign up form submission succession`, {
      via: `[Auth] Demo Sign Up Page`,
    })
    trackEvent(`demo_signup`)
    // if (!!salesRefQueryString) trackEvent(`demo_signup:${salesRefQueryString}`)
  }

  return (
    <SplashLayout className={className} testId={testId}>
      <Stack className={cx("gap-8 w-full max-w-[480px]")}>
        <header>
          <Stack className="gap-2 items-center">
            <TextLink href="/" testId="brandLink">
              <BrandMark className="w-[220px] h-auto" />
            </TextLink>
            <BrandTagline className="text-center" />
          </Stack>
        </header>
        <main>
          {panel === "disabled" && <DemoSignUpDisabledNotice />}
          {panel === "form" && <DemoSignUpForm onSuccess={handleSuccess} />}
          {panel === "success" && <DemoSignUpConfirmation email={email} />}
        </main>
      </Stack>
    </SplashLayout>
  )
}
